import React from 'react';

const TermsAndConditionsAgronetPlus = () => (
    <iframe
        title='AgroNet Plus — Terms and Conditions'
        src='/terms_and_conditions_agronet_plus.html'
        style={{ display: 'block', width: '100%', height: '100vh', border: 0 }}
    />
);

export default TermsAndConditionsAgronetPlus;
